module.exports = __webpack_public_path__ + "media/images/greennote 6-74c0f8d2c54bf6f39a4197ee1d2cc5ab.svg";